import {createAction} from '@reduxjs/toolkit';
import {Statistics} from 'client/common/types/brandlift/types';

export const setStatistics = createAction<Statistics>('SET_STATISTICS');
export const fetchBrandliftStats = createAction<StatsPayload | undefined>('FETCH_BRANDLIFT_STATS');

export interface StatsPayload {
    filter: {
        key: string;
        value: string;
    };
}
